import { useContext, useMemo } from "react";
import { DataContext } from "../context/DataContext";

// Import IDMatchPlus locale files
import idmatchplusEn from "../locales/idmatchplus/en.json";
import idmatchplusEs from "../locales/idmatchplus/es.json";

// Import Brazil CPF locale files
import brazilCpfEn from "../locales/brazil-cpf/en.json";
import brazilCpfEs from "../locales/brazil-cpf/es.json";
import brazilCpfPtBR from "../locales/brazil-cpf/pt-BR.json";

const locales = {
  idmatchplus: {
    en: idmatchplusEn,
    es: idmatchplusEs,
  },
  "brazil-cpf": {
    en: brazilCpfEn,
    es: brazilCpfEs,
    "pt-BR": brazilCpfPtBR,
  },
};

/**
 * Hook to get localized text for components
 * Supports IDMatchPlus and Brazil CPF components
 * Defaults to English if language is not set or unsupported
 */
const useLocale = (component = "idmatchplus") => {
  const { settings } = useContext(DataContext);

  const locale = useMemo(() => {
    const language = settings?.language?.toLowerCase();
    const componentLocales = locales[component];

    if (!componentLocales) {
      console.warn(`No locales found for component: ${component}`);
      return locales.idmatchplus.en;
    }

    // Default to English if language is not set or empty
    if (!language || language === "" || language === "en") {
      return componentLocales.en;
    }

    // Spanish support for all components
    if (language === "es" && componentLocales.es) {
      return componentLocales.es;
    }

    // Brazil CPF: Portuguese Brazilian support
    // Handle various codes: br, pt, pt-br, pt_br, portuguese
    if (component === "brazil-cpf") {
      if (language === "br" || language === "pt" || language === "pt-br" ||
          language === "pt_br" || language === "portuguese") {
        return componentLocales["pt-BR"];
      }
    }

    // Fallback to English for any unsupported language
    return componentLocales.en;
  }, [settings?.language, component]);

  return locale;
};

export default useLocale;
